// src/components/AdBanner.tsx
import { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle?: any[];
  }
}

export function AdBanner() {
  useEffect(() => {
    try {
      // Check if we're not in localhost/development environment
      if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
        // Push the ad after component mounts
        if (window.adsbygoogle) {
          window.adsbygoogle.push({});
        }
      }
    } catch (error) {
      // Silently handle ad initialization errors
    }
  }, []);

  // For development/localhost, show a placeholder
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    return (
      <div className="w-full bg-gray-100 border border-gray-200 rounded-lg p-4 mt-4 mb-4 text-center text-gray-600">
        Responsive Ad 1 BuyHomeCalc (Placeholder in Development)
      </div>
    );
  }

  return (
    <div className="w-full mt-4 mb-4">
      {/* We don't need to include the script tag again as it's already in index.html */}
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-7944313434367304"
        data-ad-slot="7302894032"
        data-ad-format="auto"
        data-full-width-responsive="true"></ins>
    </div>
  );
}